import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Samples from "@/pages/Samples";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/samples" element={<Samples />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
      <div className="noise-overlay" aria-hidden="true" />
    </div>
  );
}

export default App;
